import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

import { type UUID } from '~/types/common';

import { type UpdateCustomFieldPayload } from './types';
import { updateCustomField } from './updateCustomField';

/**
 * Custom hook for updating a custom field using mutations.
 *
 * @returns An object containing the mutation function and other properties.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Custom-Field/operation/update_custom_field_custom_field__custom_field_id__put
 */
export const useMutationUpdateCustomField = (options?: UseMutationOptions) => {
  return useMutation({
    mutationFn: async ({
      customFieldId,
      customFieldData,
    }: {
      customFieldId: UUID;
      customFieldData: UpdateCustomFieldPayload;
    }) => updateCustomField(customFieldId, customFieldData),
    ...options,
  });
};
